import { pushEvent, pushData } from '../../utils/datalayer';
import { intersectionViewportObserver } from 'Utils/';

const UAEVENT = 'uaevent';
let initialProductData = [];

function parseData(data) {
  return typeof data === 'string' ? JSON.parse(data) : data;
}

function handleNavClick(el, binding) {
  el.addEventListener('click', () => {
    const mql = window.matchMedia('(max-width: 1024px)');
    const clickArea = mql.matches ? 'burger menu' : 'header';
    pushEvent({
      event: UAEVENT,
      event_name: 'menu_click',
      click_area: clickArea,
      breadcrumb: binding.value.label,
    });
  });
}

function handleDetailOpen(el, binding) {
  const data = binding.value.data;
  const eventData = parseData(data);
  const onToggle = () => {
    if (el.open) return;
    pushEvent(eventData);
  };
  el.querySelector('summary').addEventListener('click', onToggle);
}

function handleProductEvents(el, binding, arg) {
  const data = binding.value.data;
  const editData = parseData(data);
  
  const onEvent = function (event) {
    if (
      event.type === 'click' &&
      (arg === 'productclick' || arg === 'ctaclicktag')
    ) {
      pushEvent(editData);
    }
  };
  
  const onImpression = function () {
    if (arg === 'productimpression') {
      initialProductData.push(editData);
      setTimeout(function () {
        if (initialProductData.length > 0) {
          let processedProductData = initialProductData.reduce(function (s, a) {
            s = [...s, ...a.ecommerce.impressions];
            return s;
          }, []);
          let processedDataLayerImpression = initialProductData[0];
          processedDataLayerImpression.ecommerce.impressions =
            processedProductData;
          pushEvent(processedDataLayerImpression);
          initialProductData = [];
        }
      }, 700);
    }
  };
  
  el.addEventListener('click', onEvent);
  intersectionViewportObserver(el, { checkIsVisible: true }).then(onImpression);
}

function handlePageData(binding) {
  const data = binding.value.data;
  const sendData = parseData(data);
  pushData(sendData);
}

function handleOnVisible(el, binding) {
  const data = binding.value.data;
  const editData = parseData(data);
  intersectionViewportObserver(el, { checkIsVisible: true }).then(() =>
    pushEvent(editData)
  );
}

function handleViewPromotion(el, binding) {
  const data = binding.value;
  const editData = parseData(data);
  intersectionViewportObserver(el, { checkIsVisible: true }).then(() => {
    pushEvent(editData);
  });
}

export const tagging = {
  name: 'lp-tagging',
  inserted: (el, binding) => {
    const { arg } = binding;

    if (arg === 'navclick') {
      handleNavClick(el, binding);
    } else if (arg === 'detailopen') {
      handleDetailOpen(el, binding);
    } else if (
      binding.value &&
      (arg === 'productclick' ||
        arg === 'productimpression' ||
        arg === 'ctaclicktag')
    ) {
      handleProductEvents(el, binding, arg);
    } else if (arg === 'pagedata') {
      handlePageData(binding);
    } else if (arg === 'onvisible') {
      handleOnVisible(el, binding);
    } else if (arg === 'viewpromotion') {
      handleViewPromotion(el, binding);
    }
  },
};
